/**
 * Returns durations based on company interval
 *
 * @param company user's company
 * @param min min duration (including this value)
 * @param max max duration (including this value)
 */
export function getTimeIntervals(
  company: any,
  min?: number,
  max?: number
): string[] {
  if (!company || !company.interval) {
    return [];
  }
  const intervals: string[] = [];
  let interval = min || min === 0 ? min : company.interval;

  const count = ((max || 360) - interval) / company.interval;
  for (let i = 0; i <= count; i++) {
    if (interval < 10) {
      intervals.push(`0${interval}`);
    } else {
      intervals.push(interval.toString());
    }
    interval += company.interval;
  }
  return intervals;
}
